import React from 'react'
import { useParams } from 'react-router-dom'
import AffiliateInsightsMaster from '../components/AffiliateInsightsMaster'
import AffiliateBankAccountsPanel from '../components/AffiliateBankAccountsPanel'
import AffiliateMonthlySummaryPanel from '../components/AffiliateMonthlySummaryPanel'
import AffiliatePayoutsPanel from '../components/AffiliatePayoutsPanel'

export default function AffiliateDetailsPage() {
  const { id } = useParams()
  const [refreshKey, setRefreshKey] = React.useState(0)

  function handlePayoutChanged() {
    setRefreshKey((prev) => prev + 1)
  }

  if (!id) return null

  return (
    <div className="mx-auto w-full max-w-[1550px] p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Detalhes do Afiliado</h1>
        <p className="text-sm text-foreground/70">Visao completa de receita, comissoes e referidos.</p>
      </div>
      <AffiliateInsightsMaster affiliateUserId={id} refreshKey={refreshKey} />
      <AffiliateMonthlySummaryPanel affiliateUserId={id} onPayoutCreated={handlePayoutChanged} />
      <AffiliatePayoutsPanel affiliateUserId={id} refreshKey={refreshKey} />
      <AffiliateBankAccountsPanel affiliateUserId={id} />
    </div>
  )
}
